import React from "react";
import test from './../assets/termsConditions.webp';
import SEO from "../seo/SEO";
import config from "../config/config";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (

    <>

      <SEO
          robots="noindex, follow"
          title="Privacy Policy - Withrow Knives"
          description="Learn how Withrow Knives collects, uses, and protects your personal data. We prioritize privacy and secure transactions."
          url={`${config.metadata.siteUrl}/privacy-policy`}
      />


      <div className="page-wrapper">
        <div 
          className="page-title" 
          style={{ backgroundImage: `url(${test})`, backgroundSize: "cover", backgroundPosition: "center" }}
        >
          <h1>Privacy Policy</h1>
          <p className="page-subtitle">Last updated March 27, 2025.</p>
        </div>

        <div className="page-content-section terms-content">

          <section aria-labelledby="privacy-introduction">
            <h2 id="privacy-introduction">Introduction</h2>
            <p>
              This Privacy Policy explains how <strong>Withrow Knives</strong> ("we", "us", or "our") collects, uses, and protects your personal information when you use our website. By using our site, you agree to the practices described in this policy.
            </p>
          </section>

          <section aria-labelledby="privacy-personal-info">
            <h2 id="privacy-personal-info">What We Collect</h2>
            <p>
              We may collect personally identifiable information when you:
            </p>
            <ul>
              <li>Place an order</li>
              <li>Create or manage an account</li>
              <li>Submit a form or contact us directly</li>
            </ul>
            <p>
              This may include your name, email address, mailing address, and phone number. Providing this information is voluntary, but certain features of the website may not function without it.
            </p>
            <p>
              <strong>We do not collect, store, or have access to your full payment information.</strong> All payments are securely processed and handled <strong>by Stripe</strong>.
            </p>
          </section>

          <section aria-labelledby="privacy-non-personal">
            <h2 id="privacy-non-personal">Non-Personal Information</h2>
            <p>
              We may automatically collect non-personal information, such as browser type, device information, IP address, and general usage data to analyze site performance and improve the user experience.
            </p>
          </section>

          <section aria-labelledby="privacy-cookies">
            <h2 id="privacy-cookies">Cookies</h2>
            <p>
              Our website uses cookies to enhance functionality and remember user preferences. You can disable cookies in your browser settings, but this may affect site performance or functionality.
            </p>
          </section>

          <section aria-labelledby="privacy-how-we-use">
            <h2 id="privacy-how-we-use">How We Use Your Information</h2>
            <ul>
              <li>To provide customer support and respond to inquiries</li>
              <li>To process orders securely and deliver your products</li>
            </ul>
          </section>

          <section aria-labelledby="privacy-security">
            <h2 id="privacy-security">Security</h2>
            <p>
              We take reasonable measures to protect your data, including SSL encryption and secure third-party services, as well as encryption of sensitive information at every step as well as at rest. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security. We recommend enabling two-factor authentication in your account.
            </p>
          </section>

          <section aria-labelledby="privacy-sharing">
            <h2 id="privacy-sharing">Third-Party Sharing</h2>
            <p>
              We do not sell or rent your personal information, and do not share any information with any third parties.
            </p>
          </section>

          <section aria-labelledby="privacy-changes">
            <h2 id="privacy-changes">Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically. The "Last updated" date above reflects the latest changes. We encourage you to review this page regularly to stay informed.
            </p>
          </section>

          <section aria-labelledby="privacy-contact">
          <h2 id="privacy-contact">Contact Us</h2>
          <p>
            For questions about this Privacy Policy or how we handle your data, please contact us at:
          </p>
          <div className="terms-contact">
            <strong>Email:</strong> <a href={`mailto:${config.contactEmail}`}>{config.contactEmail}</a><br />
            Or <Link to="/contact">click here</Link> to submit a contact form.
          </div>
        </section>
        </div>
      </div>

    </>
  );
};

export default PrivacyPolicy;